export enum DropdownType {
  DEFAULT = 'default',
  COLOR = 'color',
  SMALL_IMAGE = 'small_image',
  MEDIUM_IMAGE = 'medium_image',
  LARGE_IMAGE = 'large_image',
}
